<template>
  <!-- modal: type-xlarge -->
  <AbstractPop :type-mo-full="true">
    <template v-slot>
      <div id="CYB_PC_TO_02_02" class="modal type-mo-full" data-popup>
        <div class="dialog type-xlarge type-non-footer">
          <header class="dialog-header">
            <h2 class="dialog-title only-pc">조색기관리</h2>
            <button
              type="button"
              class="dialog-close"
              data-popup-close
              @click="() => emits('close')"
            >
              <span class="c-icon icon-large-x"></span>
              <span class="sr-only">팝업 닫기</span>
            </button>
          </header>

          <div class="dialog-content">
            <div class="dialog-content-inner">
              <!-- D: MO에서만 존재 -->
              <h3 class="c-title-level3 only-mo">조색기관리</h3>
              <!-- // D: MO에서만 존재 -->
              <div class="c-round-box">
                <ul class="c-dot-list">
                  <li>
                    보유하고 있는 조색기를 등록하시면 신규 설치 업데이트 파일
                    정보를 카카오톡 알림으로 받을 수 있습니다.
                  </li>
                </ul>
              </div>
              <div class="c-swich-area">
                <!-- D: 일반조색기 -->
                <ul>
                  <li
                    class="c-swich-item"
                    v-for="(item, idx) in data.list.list01"
                    :key="idx"
                  >
                    <div class="text">
                      <p class="date">
                        <span>
                          {{
                            item.regDt != null
                              ? item.useYn == "Y"
                                ? "등록일: "
                                : "등록 취소일: "
                              : "미등록"
                          }}
                          {{
                            item.regDt != null
                              ? item.useYn == "Y"
                                ? item.regDt
                                : item.mdfcnDt
                              : null
                          }}
                        </span>
                      </p>
                      <p class="name">
                        {{ item.prdctSeNm }}-{{ item.cmmPntSeNm }}
                      </p>
                    </div>

                    <div class="c-swich">
                      <input
                        type="checkbox"
                        :id="'tintinggroup1-' + idx"
                        name="tintinggroup1"
                        :checked="item.useYn == 'Y'"
                        @click="btnCmd(item)"
                      />
                      <label :for="'tintinggroup1-' + idx">
                        <span><span class="chk_no">미</span>등록</span>
                      </label>
                    </div>
                  </li>
                </ul>
                <!-- // D: 일반조색기 -->
                <!-- D: 팬톤조색기 -->
                <ul>
                  <li
                    class="c-swich-item"
                    v-for="(item, idx) in data.list.list02"
                    :key="idx"
                  >
                    <div class="text">
                      <p class="date">
                        <span>
                          {{
                            item.regDt != null
                              ? item.useYn == "Y"
                                ? "등록일: "
                                : "등록 취소일: "
                              : "미등록"
                          }}
                          {{
                            item.regDt != null
                              ? item.useYn == "Y"
                                ? item.regDt
                                : item.mdfcnDt
                              : null
                          }}
                        </span>
                      </p>
                      <p class="name">
                        {{ item.prdctSeNm }}-{{ item.cmmPntSeNm }}
                      </p>
                    </div>

                    <div class="c-swich">
                      <input
                        type="checkbox"
                        :id="'tintinggroup2-' + idx"
                        name="tintinggroup2"
                        :checked="item.useYn == 'Y'"
                        @click="btnCmd(item)"
                      />
                      <label :for="'tintinggroup2-' + idx">
                        <span><span class="chk_no">미</span>등록</span>
                      </label>
                    </div>
                  </li>
                </ul>
                <!-- // D: 팬톤조색기 -->
              </div>
            </div>
          </div>
        </div>
        <!-- D: dimmed -->
        <div class="dimmed"></div>
      </div>
    </template>
  </AbstractPop>
</template>
<script setup name="colorCombinMngPop">
import {
  defineProps,
  onMounted,
  reactive,
  inject,
  defineEmits,
  computed,
} from "vue";

import * as cmUtil from "@/utils/cmUtil.js";
import { api } from "@/plugins/api";

import AbstractPop from "@/components/paintpro/common/AbstractPop.vue";

const url = inject("url_prefix");
const emits = defineEmits(["close"]);

const props = defineProps({
  data: {},
  my: {},
});

const data = reactive({
  list: {
    list01: [],
    list02: [],
  },
});

const todayDate = computed(() => {
  const now = new Date();
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  return now.toLocaleDateString("en-CA", options);
});

/**********************
 * 마운트
 *********************/
onMounted(() => {
  pageInit(); // 초기셋팅
});

/*********************
 * 페이지 초기함
 *********************/
async function pageInit() {
  await filterList(props.data, props.my);
}

async function filterList(info, my) {
  // 01: 일반 / 02: 팬톤
  let list01 = [];
  let list02 = [];

  // MY조색기가 있는 경우
  if (my.length > 0) {
    for (let i in info) {
      for (let j in my) {
        if (
          info[i].prdctSeCd == my[j].prdctSeCd &&
          info[i].cmmPntSeCd == my[j].cmmPntSeCd
        ) {
          info[i].useYn = my[j].useYn;
          info[i].extCmmSn = my[j].extCmmSn;
          info[i].regDt = my[j].regDt;
          info[i].mdfcnDt = my[j].mdfcnDt;
        }
      }
    }
  }

  // 일반 / 팬톤 구분해서 리스트업
  for (let i in info) {
    if (info[i].prdctSeCd == "G") {
      list01.push(info[i]);
    } else {
      list02.push(info[i]);
    }
  }

  data.list.list01 = list01;
  data.list.list02 = list02;
}

/**********************
 * 버튼 클릭 모음
 *********************/
async function btnCmd(chkItem) {
  const res = await api.post(`${url}/colorCombin/insertMyCombinMng`, {
    extCmmSn: chkItem.extCmmSn != "" ? chkItem.extCmmSn : 0,
    prdctSeCd: chkItem.prdctSeCd,
    cmmPntSeCd: chkItem.cmmPntSeCd,
    useYn: chkItem.useYn == "Y" ? "N" : "Y",
  });

  if (res.resultCode == 200) {
    if (chkItem.useYn == "Y") {
      await cmUtil.alert(
        chkItem.prdctSeNm +
          "-" +
          chkItem.cmmPntSeNm +
          " 조색기가 MY 조색기로 등록 취소되었습니다."
      );
    } else {
      await cmUtil.alert(
        chkItem.prdctSeNm +
          "-" +
          chkItem.cmmPntSeNm +
          " 조색기가 MY 조색기로 등록되었습니다."
      );
    }
    const res2 = await api.post(`${url}/colorCombin/selectMyUpdateList`, {
      agencySn: null,
    });
    console.log(res2);
    let list01 = [];
    let list02 = [];
    for (let i in res2.data) {
    if (res2.data[i].prdctSeCd == "G") {
      list01.push(res2.data[i]);
    } else {
      list02.push(res2.data[i]);
    }
  }
    if (chkItem.prdctSeCd == "G") {
      await settingData(data.list.list01, chkItem, list01);
    } else {
      await settingData(data.list.list02, chkItem, list02);
    }
  }
}

/**********************
 * 선택 후 날짜 및 문구 수정
 *********************/
async function settingData(list, checkItem, res2) {
  for (let i in list) {
    if (list[i].cmmPntSeCd == checkItem.cmmPntSeCd) {
      list[i].regDt = todayDate.value;
      list[i].mdfcnDt = todayDate.value;
      list[i].useYn = checkItem.useYn == "Y" ? "N" : "Y";

      // extCmmSn을 res2에서 매칭해서 넣기
      const matched = res2.find(item => item.cmmPntSeCd == list[i].cmmPntSeCd);
      if (matched) {
        list[i].extCmmSn = matched.extCmmSn;
      }
    }
  }
}
</script>
